<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import ModalKonfirmasiSimpanKompetensi from "./modal-konfirmasi-simpan-kompetensi.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  components: {
    Datatable,
    Pagination,
    ModalKonfirmasiSimpanKompetensi,
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Pohon Profesi", name: "pohon_profesi" },
      { width: "auto", label: "Dahan Profesi", name: "dahan_profesi" },
      { width: "auto", label: "Nama Profesi", name: "profesi" },
      { width: "auto", label: "Kode Kompetensi", name: "kode_kompetensi" },
      { width: "auto", label: "Nama Kompetensi", name: "nama_kompetensi" },
      { width: "auto", label: "Level Kompetensi", name: "level_kompetensi" },
      { width: "200px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Pemilihan Kompetensi",
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      sessionUserId: localStorage.session_user_id,

      // jumlah kompetensi target, berasal dari work_order_detail pegawai ini
      // (dikirim BE sebagai field tambahan di response GET pemilihan-kompetensi)
      jumlahKompetensiTarget: 0,
      summaryLoading: true,
      isSaving: false,
      showKonfirmasiModal: false,
      // simpan status checklist per idkompetensi, tetap ada walau pindah halaman/pagination
      selectedMap: {},
      // cache detail kompetensi (kode, nama, dst) per idkompetensi begitu halamannya
      // pernah termuat, dipakai untuk menampilkan daftar di modal konfirmasi simpan
      selectedDetails: {},

      optionProfesi: [],
      optionDahanProfesi: [],

      tableData: {
        columns: columns,
        sortKey: "profesi",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          search: '',
          column: 'profesi',
          dir: 'asc',
          page: 1,
          per_page: 10,
          profesi: "",
          dahan_profesi: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },
  async mounted() {
    this.getProfesi();
    this.getDahanProfesi();
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
    this.filterDahanProfesi = _.debounce(
      this.searchDahanProfesi.bind(this),
      500
    );

    await this.getKompetensiTerpilih();
    await this.getDataTable();
    this.summaryLoading = false;
  },
  computed: {
    selectedCount() {
      return Object.values(this.selectedMap).filter(Boolean).length;
    },
    selectedList() {
      return Object.keys(this.selectedMap)
        .filter((id) => this.selectedMap[id])
        .map((id) => {
          const detail = this.selectedDetails[id];
          return {
            idkompetensi: Number(id),
            kode_kompetensi: detail?.kode_kompetensi || "-",
            nama_kompetensi:
              detail?.nama_kompetensi || `Kompetensi ID ${id} (belum termuat)`,
            level_kompetensi: detail?.level_kompetensi?.nama_level || "-",
            terpilih_otomatis: !!detail?.terpilih_otomatis,
            dapat_diubah: !!detail?.dapat_diubah,
          };
        });
    },
  },
  methods: {
    async searchProfesi(search, loading) {
      loading(true);
      await this.getProfesi(search, loading);
    },
    async getProfesi(search = "", loading) {
      await axios
        .get(process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all", {
          params: {
            search: search,
            limit: 100,
          },
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        })
        .then((response) => {
          this.optionProfesi = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchDahanProfesi(search, loading) {
      loading(true);
      await this.getDahanProfesi(search, loading);
    },
    async getDahanProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/dahan-profesi/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        )
        .then((response) => {
          this.optionDahanProfesi = response.data.data;
          if (loading) loading(false);
        });
    },
    // request khusus: ambil seluruh idkompetensi yang sudah terchecklist/terpilih
    // untuk pegawai ini, tidak terikat pagination/filter tabel. Dijalankan sebelum
    // getDataTable() supaya kompetensi yang belum termuat di halaman manapun tetap
    // sudah dianggap terpilih (masuk hitungan & payload simpan) sejak awal.
    async getKompetensiTerpilih() {
      let self = this;
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "pegawai/pemilihan-kompetensi/get-autocheck-kompetensi",
          {
            params: {
              id_pegawai: this.sessionUserId,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200 && response_data.data.status) {
            (response_data.data.data || []).forEach((id) => {
              self.selectedMap[id] = true;
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    getDataTable(resetPage = true) {
      let self = this;
      self.tableData.loading = true;
      if (resetPage) {
        self.tableData.filter.page = 1;
      }

      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "pegawai/pemilihan-kompetensi",
        params: {
          id_pegawai: this.sessionUserId,
          ...self.tableData.filter,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let response_data_fix = response_data.data;
            self.tableData.data = response_data_fix.data.data.map((item) => {
              // simpan/refresh detail kompetensi untuk keperluan modal konfirmasi simpan
              self.selectedDetails[item.idkompetensi] = item;
              // hanya inisialisasi sekali per idkompetensi, agar checklist yang
              // sudah di-toggle user di halaman lain tidak tertimpa saat kembali
              // ke halaman ini. sudah_dipilih mencakup auto-select maupun
              // kompetensi non-auto yang sebelumnya sudah tersimpan.
              if (!(item.idkompetensi in self.selectedMap)) {
                self.selectedMap[item.idkompetensi] = !!item.sudah_dipilih;
              }
              return {
                ...item,
                dipilih: self.selectedMap[item.idkompetensi],
              };
            });
            self.configPagination(response_data_fix.data);
            // TODO: sesuaikan nama field setelah BE final (placeholder: jumlah_kompetensi_target)
            self.jumlahKompetensiTarget =
              response_data_fix.jumlah_kompetensi_target;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
          self.tableData.loading = false;
        })
        .catch((errors) => {
          console.log(errors);
          self.tableData.loading = false;
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir = self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toggleSelect(row_data) {
      this.selectedMap[row_data.idkompetensi] = row_data.dipilih;
    },
    // hapus satu kompetensi dari daftar terpilih lewat tombol "Hapus" di modal
    // konfirmasi. Selain unset di selectedMap (dipakai selectedList/selectedCount),
    // checkbox di datatable juga disamakan bila halamannya sedang termuat
    removeKompetensiTerpilih(idkompetensi) {
      this.selectedMap[idkompetensi] = false;
      const row = this.tableData.data.find(
        (row_data) => row_data.idkompetensi === idkompetensi
      );
      if (row) {
        row.dipilih = false;
      }
    },
    // ambil nama_kompetensi & level_kompetensi untuk sekumpulan idkompetensi,
    // dipakai supaya modal konfirmasi selalu menampilkan data lengkap walau
    // idnya berasal dari halaman pagination yang belum pernah dibuka
    async getDetailKompetensi(idkompetensi) {
      return axios.post(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "pegawai/pemilihan-kompetensi/get-detail-kompetensi",
        {
          id_pegawai: this.sessionUserId,
          idkompetensi: idkompetensi,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        }
      );
    },
    simpanPemilihan() {
      let self = this;
      const idkompetensiTerpilih = Object.keys(self.selectedMap)
        .filter((id) => self.selectedMap[id])
        .map((id) => Number(id));

      if (idkompetensiTerpilih.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Perhatian",
          text: "Pilih minimal satu kompetensi terlebih dahulu.",
        });
        return;
      }

      Swal.fire({
        title: "Memuat data kompetensi...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      self
        .getDetailKompetensi(idkompetensiTerpilih)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200 && response_data.data.status) {
            (response_data.data.data || []).forEach((item) => {
              self.selectedDetails[item.idkompetensi] = {
                ...self.selectedDetails[item.idkompetensi],
                ...item,
              };
            });
          }
          Swal.close();
          self.showKonfirmasiModal = true;
        })
        .catch((errors) => {
          console.log(errors);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Gagal memuat detail kompetensi yang dipilih.",
          });
        });
    },
    konfirmasiSimpan() {
      let self = this;
      const idkompetensiTerpilih = Object.keys(self.selectedMap)
        .filter((id) => self.selectedMap[id])
        .map((id) => Number(id));

      self.isSaving = true;
      axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "pegawai/pemilihan-kompetensi",
          {
            id_pegawai: this.sessionUserId,
            idkompetensi: idkompetensiTerpilih,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.meta.code == 200) {
            self.showKonfirmasiModal = false;
            Swal.fire({
              icon: 'success',
              title: 'Berhasil',
              text: response.data.meta.message || "Data berhasil disimpan",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
              didClose: () => {
                // type_in_here
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              errors.response?.data?.data ||
              "Terjadi kesalahan saat menyimpan data",
          });
        })
        .finally(() => {
          self.isSaving = false;
        });
    },
  },
};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12 col-lg-3 col-sm-3 fw-bold">
          Jumlah kompetensi target
        </div>
        <div class="col-12 col-lg-9 col-sm-9">
          <i class="fas fa-spinner fa-spin" v-if="summaryLoading"></i>
          <template v-else>{{ jumlahKompetensiTarget }}</template>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12 col-lg-3 col-sm-3 fw-bold">
          Jumlah kompetensi terpilih
        </div>
        <div class="col-12 col-lg-9 col-sm-9">
          <i class="fas fa-spinner fa-spin" v-if="summaryLoading"></i>
          <template v-else>{{ selectedCount }}</template>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <h4 class="fw-bold mb-0">Daftar Pemilihan Kompetensi</h4>
          <button
            type="button"
            class="btn btn-primary btn-sm fw-bold"
            :disabled="isSaving"
            @click="simpanPemilihan"
          >
            <i class="fas fa-spinner fa-spin me-1" v-if="isSaving"></i>
            <i class="fas fa-save me-1" v-else></i>
            Simpan Pemilihan Kompetensi
          </button>
        </div>
      </div>

      <div class="row mb-2">
        <div class="form-group col-md-3 mb-3">
          <label for="filterDahanProfesi">Dahan Profesi</label>
          <v-select
            id="filterDahanProfesi"
            class="style-chooser"
            :options="optionDahanProfesi"
            :reduce="(item) => item.dp_id"
            label="dp_name"
            v-model="tableData.filter.dahan_profesi"
            placeholder="Semua Dahan Profesi"
            @search="filterDahanProfesi"
            @update:modelValue="getDataTable()"
          />
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterProfesi">Profesi</label>
          <v-select
            id="filterProfesi"
            class="style-chooser"
            :options="optionProfesi"
            :reduce="(item) => item.id_mprofesi"
            label="nama_profesi"
            v-model="tableData.filter.profesi"
            placeholder="Semua Profesi"
            @search="filterProfesi"
            @update:modelValue="getDataTable()"
          />
        </div>
      </div>

      <div class="row">
        <datatable
          :columns="tableData.columns"
          :sortKey="tableData.sortKey"
          :sortOrders="tableData.sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="tableData.loading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr
              v-else-if="!tableData.data || tableData.data.length === 0"
              class="text-center"
            >
              <td class="text-center" colspan="99">Data Tidak Tersedia</td>
            </tr>
            <tr
              v-else
              v-for="(row_data, key_data) in tableData.data"
              :key="row_data.idkompetensi"
            >
              <td class="text-center">
                {{ (tableData.pagination.from || 1) + key_data }}
              </td>
              <td class="text-center">{{ row_data?.profesi?.dahan_profesi?.pohon_profesi?.ph_name || "-" }}</td>
              <td class="text-center">{{ row_data?.profesi?.dahan_profesi?.dp_name || "-" }}</td>
              <td class="text-center">{{ row_data?.profesi?.nama_profesi || "-" }}</td>
              <td class="text-center">{{ row_data?.kode_kompetensi || "-" }}</td>
              <td class="text-center">{{ row_data?.nama_kompetensi || "-" }}</td>
              <td class="text-center">{{ row_data?.level_kompetensi?.nama_level || "-" }}</td>
              <td class="text-center">
                <input
                  type="checkbox"
                  class="form-check-input pilih-checkbox"
                  v-model="row_data.dipilih"
                  :disabled="!row_data.dapat_diubah"
                  @change="toggleSelect(row_data)"
                />
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination
        :pagination="tableData.pagination"
        @to-page="toPage"
      ></pagination>

      <ModalKonfirmasiSimpanKompetensi
        v-model="showKonfirmasiModal"
        :list="selectedList"
        :saving="isSaving"
        @confirm="konfirmasiSimpan"
        @remove="removeKompetensiTerpilih"
      />
    </div>
  </div>
</template>

<style scoped>
.pilih-checkbox {
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
}
</style>